import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()

export class MessageService {

  private readonly filterSubject = new BehaviorSubject<any>({});
  currentFilters$ = this.filterSubject.asObservable();

  setFilters(filters: any) {
    this.filterSubject.next(filters);
  }

  getFilters(): any {
    return this.filterSubject.getValue();
  }

  clearFilters() {
    this.filterSubject.next({});
  }
}
